module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/cotton_swab-790edbd4203228db23cc5fcb65572246.svg";